import { appDestination } from '../desk/app-destination';
import type { AppContext } from '@ndrc/app-sdk/client';
import type { EntityAction } from '@ndrc/app-sdk/manifest';

/** Résolution locale depuis les manifestes autorisés par le bureau ; aucune app n’est nommée. */
export function createEntityActions(
  manifests: readonly { id: string; contributes?: { entityActions?: readonly EntityAction[] } }[],
  openApp: AppContext['openApp'],
): NonNullable<AppContext['entityActions']> {
  return (entity, record) =>
    manifests.flatMap((manifest) =>
      (manifest.contributes?.entityActions ?? []).flatMap((action, index) => {
        if (
          action.entity !== entity ||
          typeof record.id !== 'string' ||
          !record.id ||
          (action.when &&
            (!Object.hasOwn(record, action.when.field) ||
              !Object.is(record[action.when.field], action.when.eq)))
        )
          return [];
        const route = action.route.replaceAll(':id', encodeURIComponent(record.id));
        // La navigation reste une route relative à une application du bureau.
        if (/[\\\r\n]/u.test(route) || !appDestination(manifest.id, route)) return [];
        return [
          {
            id: `${manifest.id}:${index}:${action.intent}`,
            label: action.label,
            icon: action.icon,
            open: () => openApp(manifest.id, route),
          },
        ];
      }),
    );
}
